import { TextFieldProps, TextField as MuiTextField } from '@mui/material';

const TextField = ({ InputLabelProps, ...props }: TextFieldProps) => (
  <MuiTextField InputLabelProps={{ shrink: true, ...InputLabelProps }} {...props} />
);

export default TextField;
